// Shared with the channel-selection modal: pending QR is not a connected Web session.
export const isWhatsAppWebConnected = (status: any): boolean => status?.connected === true
  && status.connectionState === 'open' && !status.hasQr && !status.stopReconnect;
const blocked = (message: string, silent = false) => Object.assign(new Error(message), { code: 'WEB_CONNECTION_GUARD', silent });
export async function requireWhatsAppWebDisconnected(check: () => Promise<any>): Promise<void> {
  let response;
  try { response = await check(); }
  catch (error: any) {
    if (error?.status === 404 && error?.code === 'WHATSAPP_NOT_FOUND') return;
    throw blocked('Não foi possível verificar o WhatsApp Web. Tente novamente antes de conectar o Oficial.');
  }
  const status = response?.message;
  if (typeof status?.connected !== 'boolean') throw blocked('Não foi possível verificar o WhatsApp Web. Tente novamente.');
  if (isWhatsAppWebConnected(status)) throw blocked('WhatsApp Web conectado.', true);
}
